import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Admin } from '../../../components/sections';
import Section from '../../../components/Section';
import { Confirm } from 'semantic-ui-react';

class UserAccountSection extends Component {
	constructor(props) {
		super(props);
		this.state = { searchField: '', showUserView: false, isAdmin: false, user: {}, showConfirm: false, confirmContent: 'Success', confirmButton: 'Close' };
		this.onSearchFieldChange = this.onSearchFieldChange.bind(this);
		this.onSearch = this.onSearch.bind(this);
		this.onView = this.onView.bind(this);
		this.onLogin = this.onLogin.bind(this);
		this.onDeleteUserPolicy = this.onDeleteUserPolicy.bind(this);
		this.onAddUserPolicy = this.onAddUserPolicy.bind(this);
		this.onPasswordReset = this.onPasswordReset.bind(this);
		this.onChangeEmail = this.onChangeEmail.bind(this);
		this.onCloseUserView = this.onCloseUserView.bind(this);
		this.onDeleteUser = this.onDeleteUser.bind(this);
		this.onIsAdminChange = this.onIsAdminChange.bind(this);
		this.onConfirmClose = this.onConfirmClose.bind(this);
		this.onSendConfirmation = this.onSendConfirmation.bind(this);
		this.onDeliveryTester = this.onDeliveryTester.bind(this);
	}
	onSearchFieldChange(e, search) {
		this.setState({ searchField: search.value });
	}
	onSearch(e) {
		const { searchField, isAdmin } = this.state;
		const { actions } = this.props;
		actions.searchUsers({ criteria: searchField, isAdmin });
	}
	onView(e, { data }) {
		this.setState({ showUserView: true, user: data });
	}
	async onAddUserPolicy(addUserRequest) {
		const { actions } = this.props;
		await actions.addPolicyToUser(addUserRequest);
		const search = await actions.fetchUpdatedUser(addUserRequest.userId);
		const user = search.response;
		if (user) {
			this.setState({ user: { ...user } });
		}
	}
	async onDeleteUserPolicy(removeUserRequest) {
		const { actions } = this.props;
		await actions.removePolicyFromUser(removeUserRequest);
		const search = await actions.fetchUpdatedUser(removeUserRequest.userId);
		const user = search.response;
		if (user) {
			this.setState({ user: { ...user } });
		}
	}
	async onPasswordReset(userId) {
		const { actions } = this.props;
		await actions.adminSendPasswordReset(userId);
		this.setState({ showConfirm: true, confirmContent: 'Password Reset Email has been sent', confirmButton: 'OK' });
	}
	async onSendConfirmation(userId) {
		const { actions } = this.props;
		await actions.adminSendEmailConfirmation(userId);
		this.setState({ showConfirm: true, confirmContent: 'Confirmation email has been sent', confirmButton: 'OK' });
	}
	async onChangeEmail(changeRequest) {
		const { actions } = this.props;
		try {
			const result = await actions.adminChangeEmail(changeRequest);
			this.setState({ showConfirm: true, confirmContent: 'Email Address change confirmation email sent', confirmButton: 'OK' });
			return result;
		} catch (error) {
			this.setState({ showConfirm: true, confirmContent: `Failed to send Email Address change confirmation email - ${error.message}`, confirmButton: 'OK' });
			return error;
		}
	}
	onCloseUserView(e) {
		this.setState({ showUserView: false, user: {} });
	}
	onIsAdminChange(e, { checked }) {
		this.setState({ isAdmin: checked });
	}
	async onDeleteUser(deleteUserRequest) {
		const { actions } = this.props;
		await actions.adminDeleteUser(deleteUserRequest);
		this.onCloseUserView();
	}
	async onLogin(e, { data }) {
		const { actions } = this.props;
		const loginResult = await actions.loginAsUser(data.id);
		if (!loginResult.response.requiresLogin && !!loginResult.response.token) {
			actions.push('/');
		}
	}

	async onDeliveryTester(e, { data, checked }) {
		const { actions } = this.props;
		try {
			await actions.adminUpdateDeliveryTester({ userId: data.id, isDeliveryTester: checked });
			this.setState({ user: { ...data, isDeliveryTester: checked } });
		} catch (error) {
			console.log(error);
		}
	}

	onConfirmClose(e) {
		this.setState({ showConfirm: false });
	}
	render() {
		const { searchField, showUserView, user, showConfirm, confirmContent, confirmButton, isAdmin } = this.state;
		const { admin } = this.props;
		const { results } = admin.userSearch;
		return (
			<Section name='userAccounts' title='Member Accounts' color='red' mobileShow={this.props.mobileShow}>
				<Confirm open={showConfirm} content={confirmContent} confirmButton={confirmButton} onConfirm={this.onConfirmClose} cancelButton={null} />
				<Admin.ModalViewUserAccount open={showUserView} user={user} onDeletePolicy={this.onDeleteUserPolicy} onAddPolicy={this.onAddUserPolicy} onPasswordReset={this.onPasswordReset} onChangeEmail={this.onChangeEmail} onClose={this.onCloseUserView} onDeleteUser={this.onDeleteUser} onSendConfirmation={this.onSendConfirmation} onDeliveryTester={this.onDeliveryTester} />

				<Admin.UserAccounts activePage={0} itemsPerPage={10} totalItems={5} items={results} onSearchFieldChange={this.onSearchFieldChange} searchField={searchField} onSearch={this.onSearch} onView={this.onView} onLogin={this.onLogin} isAdmin={isAdmin} onIsAdminChange={this.onIsAdminChange} />
			</Section>
		);
	}
}

UserAccountSection.propTypes = {
	admin: PropTypes.object.isRequired,
	actions: PropTypes.object.isRequired,
};

export default UserAccountSection;
